import _ from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';
import { TABLE_UNMOUNT } from '../Table/tableActions';
import {
    PREVET_LOAD,
    PREVET_SUCCESS,
    PREVET_FAILURE,
    REFRESH_LEAD_TO_LIVE
} from './leadToLiveActions';

const initialState = {
    prevets: [],
    loading: false,
    error: null,
    count: 0,
    pages: 0,
    hasMore: false,
    offset: 0,
    limit: 0
};

export default function reducer(state = initialState, action = {}) {
    let newState;
    switch (action.type) {
        case REFRESH_LEAD_TO_LIVE:
            newState = {
                ...state,
                shouldRefresh: (state.shouldRefresh || 0) + 1
            };

            return _.isEqual(state, newState) ? state : newState;

        case TABLE_UNMOUNT:
            newState = {
                ...state,
                prevets: []
            };

            return _.isEqual(state, newState) ? state : newState;

        case PREVET_LOAD:
            newState = {
                ...state,
                prevets: [],
                error: null,
                loading: true
            };

            return _.isEqual(state, newState) ? state : newState;

        case PREVET_SUCCESS:
            newState = {
                ...state,
                prevets: action.prevets || [],
                count: action.count || 0,
                loading: false,
                pages: action.pages || 0,
                hasMore: action.hasMore || false,
                offset: action.offset || state.offset,
                limit: action.limit || state.limit
            };

            return _.isEqual(state, newState) ? state : newState;

        case PREVET_FAILURE:
            newState = {
                ...state,
                count: 0,
                error: action.error,
                loading: false,
                pages: 0
            };

            return _.isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getLeadToLiveEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'leadToLive')
);

export const getPrevets = createSelector(
    getLeadToLiveEntity,
    (entity) => _.get(entity, 'prevets')
);

export const getIsPrevetLoading = createSelector(
    getLeadToLiveEntity,
    (entity) => _.get(entity, 'loading')
);

export const getPrevetError = createSelector(
    getLeadToLiveEntity,
    (entity) => _.get(entity, 'error')
);

export const getPrevetErrorMessage = createSelector(
    getPrevetError,
    (error) => _.get(error, 'message')
);

export const getCount = createSelector(
    getLeadToLiveEntity,
    (entity) => _.get(entity, 'count', 0)
);

export const getPages = createSelector(
    getLeadToLiveEntity,
    (entity) => _.get(entity, 'pages', 0)
);

export const getShouldRefresh = createSelector(
    getLeadToLiveEntity,
    (entity) => _.get(entity, 'shouldRefresh', 0)
);
